import { render, staticRenderFns } from "./batchImportOrdersModal.vue?vue&type=template&id=018135a2&scoped=true"
import script from "./batchImportOrdersModal.vue?vue&type=script&lang=js"
export * from "./batchImportOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./batchImportOrdersModal.vue?vue&type=style&index=0&id=018135a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018135a2",
  null
  
)

export default component.exports